import { render, staticRenderFns } from "./ActivationBriefPaymentsRouterView.vue?vue&type=template&id=4e060460&scoped=true&"
import script from "./ActivationBriefPaymentsRouterView.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefPaymentsRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e060460",
  null
  
)

export default component.exports